import * as Contants from '../constants/InventoryConstants';

export const setInitalInventory = (payload:any) => {
    return{
        type:Contants.SET_INITIAL_INVENTORY,
        data:payload
    }
}

export const clearInventory = (payload:any) => {
    return{
        type:Contants.CLEAR_INVENTORY,
        data:payload
    }
}

export const updateIngrdientQuantity = (payload:any) => {
    return{
        type:Contants.UPDATE_INGREDIENTS_IN_INVENTORY,
        data:payload
    }
}